import type { InventoryCategoriesRecord } from '../types/pocketbase-types';
import { Badge } from '@mantine/core';

export default function CategoryDisplay({
  categories,
}: {
  categories: InventoryCategoriesRecord[];
}) {
  return (
    <>
      {categories?.map((category) => (
        <Badge key={category.id} color="blue">
          {category.name}
        </Badge>
      ))}
    </>
  );
}
